import React from "react";
import { findFirstComponentOfType } from "../internal/TextExtractor";

const REFERENCES_TEMPLATE_TAG = "referencestemplate";

function isReferencesTemplateElement(child: React.ReactNode): boolean {
    if (!React.isValidElement(child)) {
        return false;
    }
    return child.type.toString().toLowerCase() === REFERENCES_TEMPLATE_TAG;
}

function excludeReferencesTemplate(children: React.ReactNode): React.ReactNode {
    const filtered: React.ReactNode[] = [];
    React.Children.forEach(children, (child) => {
        if (!isReferencesTemplateElement(child)) {
            filtered.push(child);
        }
    });
    return filtered.length > 0 ? filtered : null;
}

/** Extract ReferencesTemplate subtree and remaining Chatbot children. */
export function partitionChatbotChildren(children: React.ReactNode): {
    referencesTemplateContent: React.ReactNode;
    otherChildren: React.ReactNode;
} {
    const referencesTemplate = findFirstComponentOfType(children, REFERENCES_TEMPLATE_TAG, true);
    const referencesTemplateContent = referencesTemplate?.props?.children ?? null;
    const otherChildren = excludeReferencesTemplate(children);

    return {
        referencesTemplateContent,
        otherChildren,
    };
}
